mutation markSavedContentAsDownloaded($id: ID!) {
  savedContent: markSavedContentAsDownloaded(id: $id) {
    id
    downloaded
  }
}
